import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import SignaturePad from "react-signature-pad-wrapper"
import Grid from "../grid"
import Button from "../button"
import { SignatureWrapper } from "./styles"

const SignatureField = ({ handleInputChange, name, initialSignature, disabled, simpleForm }) => {
  const signatureFieldRef = useRef(null)

  const resetSignature = (event) => {
    event.preventDefault()

    signatureFieldRef?.current?.signaturePad.clear()
    if (handleInputChange !== undefined) handleInputChange(name, "")
  }

  useEffect(() => {
    const onEndStroke = () => {
      if (handleInputChange !== undefined) handleInputChange(name, signatureFieldRef.current.signaturePad.toDataURL())
    }

    if (
      signatureFieldRef !== null &&
      initialSignature !== null &&
      initialSignature.length > 0 &&
      !!signatureFieldRef?.current?.signaturePad
    ) {
      signatureFieldRef?.current?.signaturePad.fromDataURL(initialSignature)
    }

    if (disabled) signatureFieldRef?.current?.signaturePad.off()

    if (!!signatureFieldRef.current && !!signatureFieldRef.current.signaturePad) {
      const current = signatureFieldRef.current

      current.signaturePad.addEventListener("endStroke", onEndStroke, false)
      return function cleanup() {
        current.signaturePad.removeEventListener("endStroke", onEndStroke)
      }
    }
  }, [signatureFieldRef, initialSignature, disabled, handleInputChange, name])

  const options = {
    backgroundColor: "white",
    borderColor: "grey"
  }

  const canvasProps = {
    style: {
      borderRadius: "0.5rem"
    }
  }

  const button = (
    <div>
      <Button variant="secondary" onClick={resetSignature}>
        Reset
      </Button>
    </div>
  )

  return (
    <Grid gap="1rem">
      <SignatureWrapper simpleForm={simpleForm}>
        <SignaturePad
          ref={signatureFieldRef}
          options={options}
          height="100"
          redrawOnResize={true}
          canvasProps={canvasProps}
        />
      </SignatureWrapper>
      {!disabled && button}
    </Grid>
  )
}

SignatureField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  initialSignature: PropTypes.string
}

SignatureField.defaultProps = {
  handleInputChange: undefined,
  name: "",
  initialSignature: "",
  disabled: false
}

export default SignatureField
